/**
 * Cargo Ports Service
 * API client for the cargo-scoped ports surface used by the Trade Operations
 * "Cargo Ports" tab (Cargo/solids flavour only).
 *
 * The behaviour lives in ``portListService`` — every trade module's port list
 * speaks the same contract, so this file only binds it to the cargo endpoints.
 */

import { createPortListService } from './portListService';

const cargoPortService = createPortListService('cargo', 'cargo');

export default cargoPortService;
